import React from 'react'
import styled from 'styled-components'
import { Medium } from 'streamr-ui/css/consts'

import NetworkIcon from '../NetworkIcon'

const SelectedTickMark = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m18.142 24.844 3.57 3.854 8.486-8.486"
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const DropdownToggleMark = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m20.243 14.243-4.245 4.245-4.243-4.243"
            stroke="#0C009A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

const Name = styled.span`
    font-size: 18px;
    color: #0c009a;
    font-weight: ${Medium};
`

const UnstyledItem = ({ chain, isSelected, isDropdown, onClick, disabled, className }) => (
    <button
        type="button"
        className={className}
        key={chain.id}
        onClick={onClick}
        disabled={!!disabled}
    >
        <NetworkIcon chainId={chain.id} />
        <Name>{chain.name}</Name>
        {isSelected && <SelectedTickMark />}
        {isDropdown && <DropdownToggleMark />}
    </button>
)

const Item = styled(UnstyledItem)`
    appearance: none;
    background: #fafafa;
    border-radius: 8px;
    border: 0;
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 0 16px;
    align-items: center;
    cursor: pointer;
    height: 88px;
    text-align: left;

    &[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }

    ${Name} {
        flex: 1;
    }
`

export default Item
